export default {
  audits: (state) => state.audits,
  stats: (state) => state.stats,
  pagination: (state) => state.pagination,
}
